/**
 * Add the forwarded locale to the headers of every ajax request
 * @param options
 */
const addForwardedLocale = (options) => {
  if (options.crossDomain) {
    return;
  }

  const { lang } = document.documentElement;
  const key = 'forwarded_locale';

  if (!lang) {
    return;
  }

  if (!('data' in options)) {
    return;
  }

  if (!options.data) {
    return;
  }

  if (typeof options.data === 'string') {
    if (options.data.includes(key)) {
      return;
    }

     
    options.data = `${options.data}&${key}=${lang}`;
    return;
  }

  if (options.data instanceof FormData) {
    if (options.data.has(key)) {
      return;
    }

    options.data.append(key, lang);
    return;
  }

  if (key in options.data) {
    return;
  }

   
  options.data[key] = lang;
};

$(() => {
  $.ajaxPrefilter(addForwardedLocale);
});
